import React from "react";

const ReferralDoctorModal = ({
  onClose,
  onChange,
  referralDoctorList,
  referralDoctor,
  onSelect,
}) => {
  return (
    <div>
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            background: "white",
            padding: "20px",
            borderRadius: "8px",
            maxWidth: "650px",
            width: "100%",
            boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            position: "relative",
          }}
        >
          {/* Header Row */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: "1px solid #ddd",
              paddingBottom: "10px",
              marginBottom: "20px",
            }}
          >
            <h2 style={{ margin: 0 }}>Referral Doctor</h2>
            <button
              onClick={onClose}
              style={{
                border: "none",
                background: "transparent",
                fontSize: "18px",
                cursor: "pointer",
              }}
            >
              ✕
            </button>
          </div>

          {/* Form - Search Bar */}
          <div
            style={{
              marginBottom: "15px",
              position: "relative",
              width: "100%",
            }}
          >
            <input
              type="text"
              value={referralDoctor}
              placeholder="Search By name (Enter at least 2 characters, don't use Dr./Dr)"
              style={{
                width: "100%",
                padding: "8px 35px 8px 10px",
                borderRadius: "20px",
                border: "1px solid #ccc",
                boxSizing: "border-box",
              }}
              onChange={onChange}
            />

            {/* Search Icon */}
            <span
              style={{
                position: "absolute",
                right: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: "16px",
                color: "#888",
                pointerEvents: "none",
              }}
            >
              🔍
            </span>

            {/* Dropdown List */}
            {referralDoctorList?.length > 0 && referralDoctor.trim() !== "" && (
              <ul
                style={{
                  listStyle: "none",
                  margin: 0,
                  padding: "5px 0",
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  background: "white",
                  border: "1px solid #ccc",
                  borderTop: "none",
                  maxHeight: "200px",
                  overflowY: "auto",
                  zIndex: 1001,
                  borderRadius: "0 0 8px 8px",
                }}
              >
                {referralDoctorList.map((doctor, idx) => (
                  <li
                    key={idx}
                    style={{
                      padding: "8px 12px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      // ✅ Send doctor info back to parent
                      onSelect({
                        id: doctor.DoctorID,
                        name: doctor.DocName,
                        specialization: doctor.specialization,
                        regNo: doctor.RegNo,
                      });
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "#f2f2f2")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = "white")
                    }
                  >
                    {doctor.DocName} - {doctor.specialization} - {doctor.RegNo}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralDoctorModal;
